import { escapeHtml } from '../escape.js';
import { editAttr, itemCollection, itemStr, labeledIntro, list, sectionOpen, str } from './helpers.js';
import type { PatternSectionT } from '../../schema/index.js';

/** menu_card — primary variant `item_list`: dishes with dotted price leaders. */
export function renderMenuCard(section: PatternSectionT): string {
  const heading = str(section.fields, 'heading');
  const items = list(section.fields, 'items')
    .map((item, index) => {
      const name = itemStr(item, 'name');
      const description = itemStr(item, 'description');
      const price = itemStr(item, 'price');
      if (!name) return '';
      const itemPath = `/items/${index}`;
      const lines = [
        `    <div class="ve-menu-card__item"${editAttr(section, itemPath)}>`,
        '      <div class="ve-menu-card__line">',
        `        <span class="ve-menu-card__name">${escapeHtml(name)}</span>`,
        '        <span class="ve-menu-card__leader" aria-hidden="true"></span>',
        `        <span class="ve-menu-card__price">${escapeHtml(price)}</span>`,
        '      </div>',
      ];
      if (description) lines.push(`      <p class="ve-menu-card__desc">${escapeHtml(description)}</p>`);
      lines.push('    </div>');
      return lines.join('\n');
    })
    .filter(Boolean)
    .join('\n');

  const parts: string[] = [
    sectionOpen(section),
    ...labeledIntro(section, 'menu-card', heading),
    itemCollection(section, 'div', 've-menu-card__items', '/items', items),
    '</section>',
  ];
  return parts.join('\n');
}
